import { motion } from "framer-motion";

export const SPECIALIST_IMG = "/consultant-specialist.jpg";
export const SPECIALIST_AVATAR = "/consultant-avatar.jpg";

export const SpecialistNote = ({ text, testid = "specialist-note", className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }}
    className={`flex items-end gap-3 ${className}`} data-testid={testid}>
    <img src={SPECIALIST_AVATAR} alt="Sveta, Beauty Specialist FineSkin" className="h-11 w-11 rounded-full object-cover border border-[#E8DEC8] shrink-0" />
    <div className="relative bg-white border border-[#E6DFD5] rounded-2xl rounded-bl-sm px-4 py-3 max-w-md">
      <p className="text-[10px] tracking-[0.22em] uppercase text-[#8C6F3E]">Sveta · La tua Beauty Specialist</p>
      <p className="text-sm text-[#2B2A27] leading-relaxed mt-1">{text}</p>
    </div>
  </motion.div>
);

export const SpecialistFigure = ({ text, testid = "specialist-figure" }) => (
  <div className="relative overflow-hidden rounded-t-[180px] bg-[#F2ECE4] border border-[#E6DFD5]" data-testid={testid}>
    <div className="absolute -top-10 -left-10 h-48 w-48 rounded-full bg-[#C5A059]/15 blur-2xl" />
    <img src={SPECIALIST_IMG} alt="Sveta, Beauty Specialist FineSkin" className="relative w-full aspect-[3/4] object-cover object-top motion-safe:animate-[fsFloat_6s_ease-in-out_infinite]" />
    {text && (
      <div className="absolute left-5 right-5 bottom-5 bg-[#FAF8F5]/95 backdrop-blur border border-[#E6DFD5] rounded-2xl px-5 py-4">
        <p className="text-[10px] tracking-[0.22em] uppercase text-[#8C6F3E]">Sveta · La tua Beauty Specialist</p>
        <p className="font-serif text-lg leading-snug mt-1 text-[#1A1A18]">{text}</p>
      </div>
    )}
  </div>
);
